import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from '../../BaseUrl/ApiClient';
import { Card, CardBody, CardHeader, Col, Container, Row, Button } from 'reactstrap';

function DetailDailySpecial() {
  const { dealId } = useParams(); 
  const history = useHistory();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!dealId) return;

    const fetchDealDetail = async () => {
      setLoading(true);
      try {
        const response = await ApiClient().get(`/admin/deal/dailySpecials/${dealId}`);
        const dealData = response.data?.responseData?.deal;

        if (!dealData) {
          toast.error('Deal not found');
          return;
        }

        setDeal(dealData);
      } catch (err) {
        toast.error(err.response?.data?.responseMessage?.[0] || 'Failed to fetch deal details');
      } finally {
        setLoading(false);
      }
    };

    fetchDealDetail();
  }, [dealId]);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!deal) {
    return <div className="text-center mt-5">No deal found</div>;
  }

  return (
    <div className="page-content">
      <ToastContainer />
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
                <CardHeader className="d-flex align-items-center">
              
                    <Button color="primary" onClick={() => history.goBack()} >
                        <i className="mdi mdi-arrow-left" />
                    </Button>
                   
                    <h4 className="mb-0 ms-2">{deal.name } Deal Detail</h4>
                </CardHeader>
              <CardBody>
                <Row>
                  {/* Photo on the left */}
                  <Col md={3} className="text-left mb-3">
                    {deal.dealPhoto?.url ? (
                      <img
                        src={deal.dealPhoto.url}
                        alt="deal"
                        className="img-fluid rounded"
                        style={{ maxHeight: '150px', objectFit: 'cover' }}
                      />
                    ) : (
                      <span>No Photo</span>
                    )}
                  </Col>

                  {/* Details on the right */}
                  <Col md={9} className="text-left">
                    <p><strong>Name:</strong> {deal.name || '-'}</p>
                    <p><strong>Price:</strong> ${deal.price || '0'}</p>
                    <p><strong>Description:</strong> {deal.description || '-'}</p>
                    <p><strong>Category:</strong> {deal.category?.name || '-'}</p>
                    <p><strong>Days:</strong> {Array.isArray(deal.days) ? deal.days.join(', ') : '-'}</p>
                    <p><strong>Status:</strong> <span
                                className={`badge ${deal.isActive ? 'bg-success' : 'bg-danger'}`}
                                style={{ padding: '0.4em 0.8em', borderRadius: '50px' }}
                              >
                                {deal.isActive ? 'Active' : 'Inactive'}
                              </span></p>

                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DetailDailySpecial;
